import React from 'react';
import type { Maybe } from '@soundxyz/utils';
import type { CurrentListeningParty } from '@hooks/usePlayButton';
import type { CSS } from '../stitches';
import { styled } from '../stitches';
import { ListeningPartyCountdown } from './ListeningPartyCountdown';
import { useTimer } from './hooks/useTimer';

export const Countdown = ({
  mintStartTimestamp,
  listeningParty,
  currentListeningParty,
  releaseCard = false,
  css = {},
  onCountdownExpire,
  small = false,
}: {
  mintStartTimestamp: number;
  currentListeningParty: CurrentListeningParty;
  listeningParty: Maybe<number>;
  releaseCard?: boolean;
  css?: CSS;
  onCountdownExpire?: () => void;
  small?: boolean;
}) => {
  const { seconds, minutes, hours, days } = useTimer({
    expiryTimestamp:
      currentListeningParty?.listeningParty ?? (listeningParty != null ? 1 : mintStartTimestamp),
    onExpire: onCountdownExpire ? () => setTimeout(onCountdownExpire, 1000) : undefined,
  });

  return (
    <CountdownContainer css={css}>
      <SubText releaseCard={releaseCard} small={small}>
        {releaseCard || (
          <>
            {listeningParty != null ? (
              <>
                <SpanToggle media="laptop">🎧 Listening Party Begins In...</SpanToggle>
                <SpanToggle media="notLaptop">Listening Party</SpanToggle>
              </>
            ) : (
              <>
                <SpanToggle media="laptop">Release Party Begins...</SpanToggle>
                <SpanToggle media="notLaptop">Release Party</SpanToggle>
              </>
            )}
          </>
        )}
      </SubText>
      <ListeningPartyCountdown
        seconds={seconds}
        minutes={minutes}
        hours={hours}
        days={days}
        variant={releaseCard ? 'feedReleaseDropped' : 'release'}
        small={small}
      />
    </CountdownContainer>
  );
};

const CountdownContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  alignItems: 'center',

  '@laptop': {
    alignItems: 'flex-start',
  },
});

const SubText = styled('p', {
  kicker: 'S',
  textTransform: 'uppercase',
  color: '$white',

  variants: {
    releaseCard: {
      true: {
        color: '$white',
      },
    },
    small: {
      true: {
        opacity: 0.5,
      },
    },
  },
});

export const SpanToggle = styled('span', {
  display: 'none',
  variants: {
    media: {
      laptop: {
        '@laptop': {
          display: 'initial',
        },
      },
      notLaptop: {
        display: 'initial',
        '@laptop': {
          display: 'none',
        },
      },
      tablet: {
        '@tablet': {
          display: 'initial',
        },
      },
      notTablet: {
        display: 'initial',
        '@tablet': {
          display: 'none',
        },
      },
    },
  },
});
